import React, { ReactElement, SyntheticEvent } from 'react';
import { ModalStyled } from '../../styledComponents';

interface IProps {
	children: ReactElement;
	onClose?: () => void;
	isOpen: boolean;
	disableTransparency: boolean;
}

function Modal(props: IProps) {
	const { children, onClose, isOpen, disableTransparency } = props;
	const handleOutsideClick = (e: SyntheticEvent<HTMLElement>) => {
		if (onClose && (e.target as HTMLElement).id === 'ui-modal') {
			onClose();
		}
	};
	return (
		<>
			{isOpen ? (
				<ModalStyled id="ui-modal" disableTransparency={disableTransparency} onClick={handleOutsideClick}>
					{children}
				</ModalStyled>
			) : null}
		</>
	);
}

export default Modal;
